import { createContext, useContext } from 'react';

export enum MESSAGES {
  APP_LOCATION_CHANGED = 'APP_LOCATION_CHANGED',
  UNIFY_CLIENT_READY = 'UNIFY_CLIENT_READY',
  UNIFY_CLIENT_CONNECT = 'UNIFY_CLIENT_CONNECT',
  UNIFY_CLIENT_INIT_CONNECTION = 'UNIFY_CLIENT_INIT_CONNECTION',
  UNIFY_REFRESH = 'UNIFY_REFRESH',
  NOTIFICATION_RECEIVED = 'NOTIFICATION_RECEIVED',
  UNIFY_TOKEN_REQUEST = 'UNIFY_TOKEN_REQUEST',
  UNIFY_TOKEN_RESPONSE = 'UNIFY_TOKEN_RESPONSE',
  UNIFY_IP_RESTRICT_RESPONSE = 'UNIFY_IP_RESTRICT_RESPONSE',
  UNIFY_PREFERENCE_CHANGED = 'UNIFY_PREFERENCE_CHANGED',
  UNIFY_AMPLITUDE_RC_OPEN = 'UNIFY_AMPLITUDE_RC_OPEN',
  RIGHT_CLICK = 'RIGHT_CLICK',
}

export enum LOGOUT_STATUS {
  LOGOUT_USERCONFIRM = 'LOGOUT_USERCONFIRM',
  LOGOUT_INIT = 'LOGOUT_INIT',
  LOGOUT_PROGRESS = 'LOGOUT_PROGRESS',
  APPS_COMPLETE = 'APPS_COMPLETE',
  NONE = 'NONE',
}

export interface ChannelMessage {
  channelMessageEnabled: (id: string) => boolean;
  getWorkflowAppId: (wid: string) => string;
  postMessage: (frm: HTMLIFrameElement, args: any, origin: any) => void;
  initClient: (frm: HTMLIFrameElement, id: string, url: string) => void;
  addMessageListener: (src: string, listener: (evt: MessageEvent) => void) => void;
  notifyMessage: (action: string, payload: any) => void;
  endPointLogout: () => void;
  setLogoutStatus: (status: LOGOUT_STATUS) => void;
  logoutStatus: LOGOUT_STATUS;
  refreshActiveFrame: () => void;
  openAmplitudeRC: () => void;
}

export const MessageContext = createContext<ChannelMessage | null>(null);

export const useChannelMessage = (): ChannelMessage => {
  const context = useContext(MessageContext);
  if (context === null)
    throw new Error('useChannelMessage must be used within a <MessageProvider>');
  return context;
};
